import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';

interface Props {
  name: string;
  isOverCapacity?: boolean;
  variant?: 'selected' | 'dropdown';
}

export const ContractorCapacityLabel: React.FC<Props> = ({
  name,
  isOverCapacity,
  variant = 'dropdown',
}) => {
  const classes = useStyles();
  if (!isOverCapacity) return <>{name}</>;
  return (
    <span
      className={
        variant === 'selected'
          ? classes.overCapacitySelected
          : classes.overCapacity
      }
    >
      {name}
      <PriorityHighIcon fontSize="small" />
    </span>
  );
};

const useStyles = makeStyles({
  overCapacity: {
    color: '#f44336',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  overCapacitySelected: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
});
